// custom.js

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  initHeroParallax();
  initImageGridAnimations();
  initSectionAnimations();
  initCTSAnimations();
  initFeaturedBlogAnimations();
});

// ──────────────────────────────────
// Hero Parallax
// ──────────────────────────────────

function initHeroParallax() {
  const heroes = document.querySelectorAll('[data-parallax="true"]');
  if (!heroes.length) return;

  heroes.forEach((hero) => {
    const media = hero.querySelector('.hero__media-grid');
    if (!media) return;
    if (ScrollTrigger.isTouch === 1) return;

    gsap.set(media, { willChange: 'transform' });

    gsap.fromTo(
      media,
      { yPercent: -10 },
      {
        yPercent: 10,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.5,
        },
      }
    );
  });
}

// ──────────────────────────────────
// Image Grid Scroll Animations
// ──────────────────────────────────

function initImageGridAnimations() {
  const grids = document.querySelectorAll('[data-scroll-animate="true"]');
  if (!grids.length) return;

  grids.forEach((grid) => {
    const cells = grid.querySelectorAll('.image-grid__cell');
    if (!cells.length) return;

    cells.forEach((cell, index) => {
      const trigger = cell.querySelector('.image-grid__title')
        || cell.querySelector('.image-grid__subtitle')
        || cell.querySelector('.image-grid__cta-wrap');

      const elements = cell.querySelectorAll(
        '.image-grid__subtitle, .image-grid__title, .image-grid__cta-wrap'
      );
      if (!elements.length || !trigger) return;

      gsap.set(elements, { opacity: 0, y: 20 });

      gsap.to(elements, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        stagger: 0.12,
        delay: index * 0.15,
        scrollTrigger: {
          trigger: trigger,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
      });
    });
  });
}

// ──────────────────────────────────
// Generic Section Scroll Animations
// ──────────────────────────────────

function initSectionAnimations() {
  const sections = document.querySelectorAll('[data-section-animate="true"]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const contentWrapper = section.querySelector('[data-testid="section-content"]');
    if (!contentWrapper) return;

    const blocks = contentWrapper.children;
    if (!blocks.length) return;

    const borderedStrongs = section.querySelectorAll('strong');

    gsap.set(blocks, { opacity: 0, y: 15 });

    gsap.to(blocks, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      ease: 'power2.out',
      stagger: 0.15,
      scrollTrigger: {
        trigger: contentWrapper,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
      onComplete: () => {
        borderedStrongs.forEach((strong) => {
          strong.classList.add('border-visible');
        });
      },
    });
  });
}
// ──────────────────────────────────
// Collection Tabs Slider Animations
// ──────────────────────────────────

function initCTSAnimations() {
  const sections = document.querySelectorAll('[data-cts-animate="true"]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const subtitle = section.querySelector('.cts__subtitle');
    const title = section.querySelector('.cts__title');
    const tabs = section.querySelectorAll('.cts__tab');
    const arrows = section.querySelector('.cts__arrows');
    const tabsContainer = section.querySelector('.cts__tabs');
    const tabsScroll = section.querySelector('.cts__tabs-scroll');
    const panels = section.querySelector('.cts__panels');

    const headerElements = [subtitle, title].filter(Boolean);
    const tabElements = Array.from(tabs);

    // Set initial states
    if (headerElements.length) {
      gsap.set(headerElements, { opacity: 0, y: 15 });
    }
    if (tabElements.length) {
      gsap.set(tabElements, { opacity: 0, y: 10 });
      if (tabsContainer) tabsContainer.style.overflow = 'visible';
      if (tabsScroll) tabsScroll.style.overflow = 'visible';
    }
    if (arrows) {
      gsap.set(arrows, { opacity: 0 });
    }
    if (panels) {
      gsap.set(panels, { opacity: 0, y: 25 });
    }

    // Header — triggers on first header element
    if (headerElements.length) {
      gsap.to(headerElements, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        stagger: 0.1,
        scrollTrigger: {
          trigger: headerElements[0],
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      });
    }

    // Tabs + arrows — triggers on first tab pill
    if (tabElements.length) {
      const tabsTl = gsap.timeline({
        scrollTrigger: {
          trigger: tabElements[0],
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      });

      tabsTl.to(tabElements, {
        opacity: 1,
        y: 0,
        duration: 0.4,
        ease: 'power2.out',
        stagger: 0.15,
        onComplete: () => {
          if (tabsContainer) tabsContainer.style.overflow = '';
          if (tabsScroll) tabsScroll.style.overflow = '';
        },
      });

      if (arrows) {
        tabsTl.to(
          arrows,
          {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out',
          },
          '-=0.2'
        );
      }
    }

    // Panels — triggers on panels element
    if (panels) {
      gsap.to(panels, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: panels,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
      });
    }
  });
}

// ──────────────────────────────────
// Featured Blog Posts Animations
// ──────────────────────────────────

function initFeaturedBlogAnimations() {
  const sections = document.querySelectorAll('[data-fbp-animate="true"]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const bg = section.previousElementSibling;
    if (bg && bg.classList.contains('section-background')) {
      gsap.set(bg, { opacity: 0 });
      gsap.to(bg, {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
      });
    }

    const cards = section.querySelectorAll('.featured-blog-posts-card');
    if (!cards.length) return;

    cards.forEach((card, cardIndex) => {
      const image = card.querySelector('.resource-image');
      const label = card.querySelector('.featured-blog-posts-card__label');
      const contentElements = [];

      const details = card.querySelector('.blog-post-details');
      const title = card.querySelector('.featured-blog-posts-card__content h4');
      const underline = card.querySelector('.featured-blog-posts-card__title-underline');
      const excerpt = card.querySelector('.blog-post-card__content-text');
      const readMore = card.querySelector('.featured-blog-posts-card__read-more');

      [details, title, underline, excerpt, readMore].forEach((el) => {
        if (el) contentElements.push(el);
      });

      if (image) {
        gsap.set(image, { opacity: 0, scale: 1.05 });
        gsap.to(image, {
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: 'power2.out',
          delay: cardIndex * 0.15,
          scrollTrigger: {
            trigger: card,
            start: 'top 88%',
            toggleActions: 'play none none none',
          },
        });
      }

      if (label) {
        gsap.set(label, { opacity: 0, y: -10 });
        gsap.to(label, {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: 'power2.out',
          delay: cardIndex * 0.15 + 0.3,
          scrollTrigger: {
            trigger: card,
            start: 'top 88%',
            toggleActions: 'play none none none',
          },
        });
      }

      if (contentElements.length) {
        gsap.set(contentElements, { opacity: 0, y: 15 });
        gsap.to(contentElements, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: 'power2.out',
          stagger: 0.1,
          scrollTrigger: {
            trigger: card,
            start: 'center bottom',
            toggleActions: 'play none none none',
          },
        });
      }
    });
  });

  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });
}

// ──────────────────────────────────
// Refresh & Editor Support
// ──────────────────────────────────

window.addEventListener('load', () => {
  ScrollTrigger.refresh();
  setTimeout(() => ScrollTrigger.refresh(), 500);
});

document.addEventListener('shopify:section:load', () => {
  ScrollTrigger.getAll().forEach((st) => st.kill());
  initHeroParallax();
  initImageGridAnimations();
  initSectionAnimations();
  initCTSAnimations();
  initFeaturedBlogAnimations();
});